import { RootState } from 'app/store'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'

export const PublicOnlyDisplay: FC = ({ children }) => {
  const { loggedIn } = useSelector((state: RootState) => state.auth)

  return <>{!loggedIn && children}</>
}
